var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.enable)?_c('div',{staticClass:"page-loader"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"40","width":"3"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }